<template>
    <div class="form-item" v-show="item.visible">
        <el-tooltip class="item" effect="dark" placement="top-start" v-if="item.description">
            <div slot="content">
                {{item.description}}
            </div>
            <img class="form-tooltip" :src="require('@/assets/question.png')"/>
        </el-tooltip>
        <el-form-item :label="item.label" :rules="rules" :prop="item.prop">
            <el-input-number v-model="itemdata" :precision="2" :step="0.01" :max="item.max" :min="item.min" :disabled="!item.editable"></el-input-number>
            <br>
            <span v-if="!itemdata" class="prompt">{{item.prompt || ''}}</span>
        </el-form-item>
    </div>
</template>


<script>
	import utils from '@/utils'
	export default {
		name: 'float-widget',
		props: {
			editable: { type: Boolean },
			item: { type: Object },
			value: [String,  Number]
		},
		data() {
			return {
				rules: utils.generateFormRule(this.item)
			}
		},
		computed: {
			itemdata: {
				get() { return this.value },
				set(itemdata) { this.$emit('input', itemdata) }
			}
		}
	}
</script>

<style lang="stylus" scoped>

</style>

